export class StatusCounter {
    public description: string;
    public count?: number;
    public icon: string;
    public url: string;
}
